import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import styled from "styled-components";
import { rem } from "polished";
import Icon from "../../../../icons/Icon";
import { media } from "../../../../utils/uiSizes";

const Container = styled.div`
  width:136px;
  display: flex;
  align-items: center;
  padding: ${rem("5px")} ${rem("16px")} ${rem("5px")} ${rem("8px")};
  background: #E8E9EA;
  border-radius: 999px;
  color: #1A2732;
  font-family: FyranSans-SemiBold;
  font-size: 13px;
  line-height: ${rem("23px")};
  ${media.desktop`

  `} img {
    max-height: ${rem("21px")};
    padding-right: ${rem("8px")};
  }

  svg {
    fill: #1A2732;
    stroke: none;
  }

  .separator {
    height: ${rem("24px")};
    width: 1px;
    margin: 0 ${rem("12px")};
    background: #1A2732;
  }

  .time {
    font-size: 1rem;
    line-height: 23px;
    ${media.phone`
			font-size: 1rem;
			line-height: 23px;
		`};
  }
`;

class ScoreAndTime extends Component {
  countdownTimer: null;
  state = {
    timeRemainingString: null
  };

  getTimeRemaining = end => {
    const now = moment(new Date());

    const nowIsDST = now.isDST();
    const endIsDST = end.isDST();
    if (nowIsDST !== endIsDST) {
      if (endIsDST) {
        now.subtract(1, "hour");
      }
      if (nowIsDST) {
        end.subtract(1, "hour");
      }
    }
    const duration = moment.duration(end.diff(now));
    const durationMS = duration.asMilliseconds();
    const seconds = Math.floor((durationMS / 1000) % 60);
    const minutes = Math.floor((durationMS / 1000 / 60) % 60);
    const hours = Math.floor((durationMS / (1000 * 60 * 60)) % 24);
    const days = Math.floor(durationMS / (1000 * 60 * 60 * 24));
    return {
      total: durationMS,
      days,
      hours,
      minutes,
      seconds
    };
  };

  startTimerIfNeeded = campaign => {
    this.clearTimer();

    let timeRemaining;
    if (campaign && campaign.endDate) {
      const end = moment(campaign.endDate);
      timeRemaining = this.getTimeRemaining(end);
      if (timeRemaining.total > 0) {
        this.countdownTimer = setInterval(this.updateTimer, 1000);
      }
    }
    this.updateTimeString(timeRemaining);
  };

  clearTimer = () => {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  };

  updateTimer = () => {
    const { campaign } = this.props;
    const end = moment(campaign.endDate);
    const timeRemaining = this.getTimeRemaining(end);
    if (timeRemaining.total <= 0) {
      this.clearTimer();
      this.updateTimeString();
    } else {
      this.updateTimeString(timeRemaining);
    }
  };

  updateTimeString = (
    timeRemaining = { days: 0, hours: 0, minutes: 0, seconds: 0 }
  ) => {
    const { days, hours } = timeRemaining;
    const timeRemainingString = `${days}pv ${hours}h`;
    this.setState({
      timeRemainingString
    });
  };

  componentWillMount = () => {
    //start timer if we have a campaign and time left > 0
    this.startTimerIfNeeded(this.props.campaign);
  };

  componentWillReceiveProps = nextProps => {
    //start timer if we have a campaign and time left > 0 and no timer is running yet
    const { campaign } = this.props;
    if (nextProps.campaign._id !== campaign._id) {
      this.startTimerIfNeeded(nextProps.campaign);
    }
  };

  componentWillUnmount = () => {
    this.clearTimer();
  };

  render() {
    const { score, ...rest } = this.props;
    return (
      <Container {...rest}>
	      <Icon icon="#mtv-pollo" width="20px" height="20px" />
        <span  style={{marginLeft:"0.5rem"}}>{Math.floor(score)}</span>
        <div className="separator" />
        <Icon icon="#time" />
        <span className="time">{this.state.timeRemainingString}</span>
      </Container>
    );
  }
}

ScoreAndTime.propTypes = {
  score: PropTypes.number
};

ScoreAndTime.defaultProps = {
  score: 0
};

export default ScoreAndTime;



// WEBPACK FOOTER //
// ./src/modules/common/components/app/ScoreAndTime.js